'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navi = void 0;
var $ = require("jquery");
var Navi = /** @class */ (function () {
    function Navi() {
        this.windowsWidth = 0;
        this.windowsHeight = 0;
        this.headerHeight = 0;
        this.flagHasFixedHeader = false;
        this.breakpoint = 1024;
        var self = this;
        $(document).ready(function () {
            self.setSize();
            self.hasFixedHeader();
            $('.bulletFixedHeader').css({ top: -1 * self.headerHeight });
        });
        $(window).resize(function () {
            self.setSize();
            self.hasFixedHeader();
        });
        var scrollTop = 0;
        $(window).scroll(function () {
            scrollTop = $(this).scrollTop();
            if (self.flagHasFixedHeader) {
                if (scrollTop > 300) {
                    $('.bulletFixedHeader').css({ top: 0 });
                }
                else {
                    $('.bulletFixedHeader').css({ top: -1 * self.headerHeight });
                }
            }
        });
    }
    Navi.prototype.setSize = function () {
        this.windowsWidth = $(window).width();
        this.windowsHeight = $(window).height();
        this.headerHeight = $('.bulletFixedHeader').height();
    };
    Navi.prototype.hasFixedHeader = function () {
        if (this.windowsWidth > this.breakpoint) {
            this.flagHasFixedHeader = true;
        }
        else {
            this.flagHasFixedHeader = false;
            $('.bulletFixedHeader').hide();
        }
    };
    return Navi;
}());
exports.Navi = Navi;
exports.default = Navi;
